module.exports = __webpack_public_path__ + "img/logo-prisma.0cdaf721.png";